/** Base props for a group */

/** Base props for group details */

/** All the possible types for a group */

/** Available group sort fields - derived from GROUPS_SORTABLE_FIELDS */

export const GROUPS_SORT_BY = ["name_ascending", "name_descending", "members_ascending", "members_descending", "projects_ascending", "projects_descending", "created_date_ascending", "created_date_descending"];

/** All possible groups sort by values */